/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Sociaalemotioneeldomein_Inlevingsvermogen4Inputs */

const nl_enums_sociaalemotioneeldomein_inlevingsvermogen4 = /** @type {(inputs: Enums_Sociaalemotioneeldomein_Inlevingsvermogen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inlevingsvermogen`)
};

/**

* @param {Enums_Sociaalemotioneeldomein_Inlevingsvermogen4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_sociaalemotioneeldomein_inlevingsvermogen4 = /** @type {((inputs?: Enums_Sociaalemotioneeldomein_Inlevingsvermogen4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Sociaalemotioneeldomein_Inlevingsvermogen4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_sociaalemotioneeldomein_inlevingsvermogen4(inputs)
});
export { enums_sociaalemotioneeldomein_inlevingsvermogen4 as "enums.SociaalEmotioneelDomein.Inlevingsvermogen" }